import axios from 'axios';
import React, { useContext, useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Snippet from './Snippet';
import SnippetEditor from './SnippetEditor';
import './Home.scss'
import UserContext from '../../context/UserContext'
import domain from '../../util/domain'

const Home = () => {
    const [snippets, setSnippets] = useState([]);
    const [formOpen, setFormOpen] = useState(false);
    const [editData, setEditData] = useState(null);

    const {user} = useContext(UserContext);

    let sortedSnippets = [...snippets]
    sortedSnippets = sortedSnippets.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt) )

    useEffect(() => {
        if (!user) setSnippets([])
        else getSnippets()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    async function getSnippets() {
        const res = await axios.get(`${domain}/snippet/`)
        setSnippets(res.data)
        console.log(user)
    }

    function editSnippet(snippetData) {
        setEditData(snippetData)
        setFormOpen(true)
    }
    return (
        <div className="home">
            {!formOpen && user && <button className="btn-editor-toggle" onClick={() => setFormOpen(true)}>Add snippet</button>}
            {formOpen && <SnippetEditor getSnippets={getSnippets} setFormOpen={setFormOpen} editData={editData}/>}
            {snippets.length > 0 ? sortedSnippets.map((snippet, i) => (<Snippet key={i} snippet={snippet} getSnippets={getSnippets} editSnippet={editSnippet}/>)): user && <h3 className="no-snippets-msg">no snippets have been added yet</h3>}
            {!user && (<div className="no-user-msg"><h2>Welcome to Snippet Manager</h2><Link to="/register">Register here</Link></div>)}
        </div>
    )
}

export default Home
